import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

function FaqPage({ openContactModal }) {

  const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  const checkScreen = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  checkScreen();
  window.addEventListener("resize", checkScreen);

  return () => window.removeEventListener("resize", checkScreen);
}, []);

  const [activeIndex, setActiveIndex] = useState(null);
  const heroRef = useRef(null);

  // Page open hote hi scroll top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "Is Dwellora Homes a government-registered company?",
      answer:
        "Yes. Dwellora operates under Dwellora Designs LLP, a legally registered Limited Liability Partnership with the Ministry of Corporate Affairs (ROC), Government of India.<br/>This ensures compliant, accountable, and professional operations.",
    },
    {
      question: "Who leads Dwellora and what experience does the team have?",
      answer:
        "Dwellora is led by Architect Gajanan V. Shetkar, founder of S-Cube Designers & Planners (est. 2015) — bringing over 11 years of professional design and construction experience.<br/>The team also includes civil engineering partners with 20+ years of construction expertise, combining strong architectural planning with practical execution capability.",
    },
    {
      question: "How can I trust Dwellora with my home construction?",
      answer:
        "Trust for us goes beyond being a registered company or having a COA-registered architect leading the firm.<br/>At Dwellora, we believe real trust comes from complete transparency in how your home is built.<br/>From day one of construction, we provide live site camera access so you can monitor work progress anytime, from anywhere — whether you are at work or traveling.<br/>This openness ensures you always know how your home is being built, without constant follow-ups.",
    },
    {
      question: "How does Dwellora deliver high-quality construction at the right price?",
      answer:
        "Dwellora operates with a fully in-house team covering architecture, approvals, and construction execution. We do not subcontract projects to external contractors or add third-party commission layers.<br/>This integrated approach removes multiple margin layers and coordination gaps, allowing us to maintain high construction quality while keeping project costs efficient and transparent.",
    },
    {
      question: "How does Dwellora ensure on-time project delivery?",
      answer:
        "Dwellora provides a registered agreement with defined scope and completion timeline for full customer assurance.<br/>With our dedicated in-house execution team, we maintain strong schedule control — enabling reliable and timely project delivery.",
    },
    {
      question: "I already have a plot. Can Dwellora handle everything from design to construction?",
      answer:
        "Yes. Dwellora provides complete bungalow solutions — architectural design, PMRDA approvals, and construction — all managed by one professional team. You don’t need to coordinate with separate architects, engineers, and contractors.",
    },
    {
      question: "How is Dwellora different from a local contractor?",
      answer:
        "A contractor typically executes only construction.<br/>Dwellora is an architect-led, government-registered LLP delivering design, approvals, and construction together. This ensures better planning, cost control, compliance, and overall quality.",
    },
    {
      question: "I’m worried about cost overruns. How does Dwellora control budget?",
      answer:
        "We provide transparent per-sqft pricing and detailed scope before starting.<br/>Because design and construction are integrated, there are fewer changes, errors, and rework — the main reasons projects exceed budget.",
    },
   {
  question: "Do I need to arrange an architect or approval agent separately?",
  answer:
    "No, you don’t need to arrange them separately.<br/>Architecture and PMRDA liaisoning are included in Dwellora’s services. This means you get a single point of contact for design, approvals, and construction, ensuring smoother communication and project execution."
},
    {
      question: "Will my home design be customized or standard?",
      answer:
        "Every Dwellora home is custom-designed for your plot size, orientation, family needs, and vastu preferences.<br/>We focus on practical space planning, ventilation, and long-term usability — not template designs.",
    },
    {
      question: "What do your ₹1300 and ₹1900 per sqft packages include?",
      answer:
        "₹1300/sqft covers structure (RCC, brickwork, plaster) plus architectural design, drawings, and local authority approvals.<br/>₹1900/sqft includes full finishing construction along with design and approvals.<br/>Detailed specifications are shared before agreement.",
    },
    {
      question: "Who manages quality and site supervision?",
      answer:
        "Dwellora’s architectural and engineering team plans and monitors execution.<br/>Because design and construction are handled together, site decisions remain aligned with drawings and specifications.",
    },
    {
      question: "How are payments scheduled?",
      answer:
        "Payments are stage-linked to construction progress (foundation, plinth, slab, finishing, etc.).<br/>This keeps financial flow balanced and transparent for homeowners.",
    },
    {
      question: "Will approvals and regulations be properly handled?",
      answer:
        "Yes. Dwellora prepares compliant drawings and assists PMRDA approval processes.<br/>This reduces legal risk, delays, and rework during construction.",
    },
    {
      question: "Why do many plot owners choose integrated design-build firms like Dwellora?",
      answer:
        "Because a single responsible team reduces coordination stress, timeline delays, and cost variations.<br/>Homeowners get clearer accountability, smoother execution, and predictable outcomes.",
    },
  ];

  return (
    <section className="faq-page">

      {/* HERO */}
      <div className="faq-hero" ref={heroRef}>
        <div className="faq-hero-content">
          <h1>Frequently Asked Questions</h1>
          <p>
            Clear answers about pricing, approvals, construction quality,
            and how Dwellora builds homes with complete transparency.
          </p>
        </div>
      </div>

      {/* FAQ LIST */}
      <div className="faq-container">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFaq(index)}
          >
            <div className="faq-question">
              <span>{faq.question}</span>
              <span className="faq-icon">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>

            <div className="faq-answer">
              <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
            </div>
          </div>
        ))}
      </div>

      {/* BOTTOM CTA */}
      <div className="faq-bottom-wrapper">
        <div className="faq-bottom-card">
          <h3>Still Have Questions?</h3>

          <p>
            Speak directly with our architectural team and get clarity before
            you begin your home journey.
          </p>

          {/* <div className="faq-bottom-buttons">
            <a href="tel:+919158914222">
              <button className="faq-btn dark">
                <i className="bi bi-telephone-fill me-2"></i>
                Let’s Consult
              </button>
            </a>
          </div> */}

<div className="faq-bottom-buttons">
  {isMobile ? (
    <a href="tel:+919158914222">
      <button className="faq-btn dark">
        <i className="bi bi-telephone-fill me-2"></i>
        Call Now
      </button>
    </a>
  ) : (
    <button className="faq-btn dark">
      <i className="bi bi-telephone-fill me-2"></i>
      +91 9158914222
    </button>
  )}
</div>

        </div>
      </div>

    </section>
  );
}

export default FaqPage;